import { $Elements, Events } from './constants';

$Elements.document.on(Events.page.enter, () => {

	// ---------- GTM Tracking ----------

	if(typeof dataLayer !== 'undefined') {

		function dataLayerEvent(event, trigger, url) {
			let label;

			if(event === 'click_city' || event === 'click_button_header') {
				label = trigger.id;
			}
			else if(event === 'click_button_lawyer') {
				label = 'contactButtonLawyer';
			}
			else {
				label = 'ContactLink';
			}


			dataLayer.push({
				'event': event,
				'cta_label': label,
				'url': url,
			});
		}

		const contactLinks = document.querySelectorAll('a[href*="contact"]');

		if(contactLinks.length >= 1) {
			contactLinks.forEach((link) => {

				link.addEventListener('click', () => {
					const url = window.location.href;

					if(link.id.startsWith('town')) {
						dataLayerEvent('click_city', link, url);
					}
					else if(link.id === 'contactButtonHeader') {
						dataLayerEvent('click_button_header', link, url);
					}
					else if(link.id === '#contactButtonLawyer') {
						dataLayerEvent('click_button_lawyer', link, url);
					}
					else if(link.id === '#contactButtonToTop') {
						dataLayerEvent('click_button_top', link, url);
					}
					else if(link.id === '#contactButtonLawyerArchive') {
						dataLayerEvent('click_button_lawyer_archive', link, url);
					}
					else {
						dataLayerEvent('contact_link', link, url);
					}
				});
			});
		}
	}
});
